'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isImmutable;
var IS_ITERABLE = '@@__IMMUTABLE_ITERABLE__@@';
var IS_RECORD = '@@__IMMUTABLE_RECORD__@@';

function isImmutable(obj) {
  return !!(obj && (obj[IS_ITERABLE] || obj[IS_RECORD]) && !obj.__ownerID);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/is-immutable/dist/index.js
// module id = 841
// module chunks = 0